// extracted by mini-css-extract-plugin
export default {"loader":"gift_loader__0ekUC","spinner":"gift_spinner__8pdUZ"};